import type { UserShape } from '../ownership-models.ts';

export const getUserAvatarSrc = (user: UserShape): string | undefined => {
	return user.isAnonymous || !user.avatarUrl ? undefined : user.avatarUrl;
};
